import Vue from 'vue'
import GtmTracking from 'chimera/all/plugins/tracking/gtm'

export default ({ env, store }) => {
  Vue.use(GtmTracking, {
    gtmId: env.gtmId,
    // gtgPath is empty everywhere except the acceptance/production generate
    // jobs, so GTM falls back to the direct load when the relay isn't configured.
    gtgPath: env.gtgPath,
    store,
  })
}
